import { prop } from 'ramda';
import { IRealtyValuation, IPrices } from '../../types/realtyValuation';

export const getAvgPrices = (realtyValuation: IRealtyValuation): IPrices => {
  return prop('avgPrices', realtyValuation);
};
